import axios from './axios';
import { handleApiError } from './apiErrorHandler';

const enumService = {
    getNotificationTypes: async () => {
        try {
            const response = await axios.get("/enums/notification-types");
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: handleApiError(error) };
        }
    },

    getShiftTypes: async () => {
        try {
            const response = await axios.get("/enums/shift-types");
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: handleApiError(error) };
        }
    },

    getRoleTypes: async () => {
        try {
            const response = await axios.get("/enums/role-types");
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: handleApiError(error) };
        }
    },

    getUserTypes: async () => {
        try {
            const response = await axios.get("/enums/user-types");
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: handleApiError(error) };
        }
    },

    getCuisineTypes: async () => {
        try {
            const response = await axios.get("/enums/cuisine-types");
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: handleApiError(error) };
        }
    },

    getFileOfTypes: async () => {
        try {
            const response = await axios.get("/enums/fileOf-types");
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: handleApiError(error) };
        }
    },
    getMenuCategoryTypes: async () => {
        try {
            const response = await axios.get("/enums/menu-category-types");
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: handleApiError(error) };
        }
    },

     getOrderStatusTypes: async () => {
        try {
            const response = await axios.get("/enums/order-status-types");
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: handleApiError(error) };
        }
    },
    
};

export default enumService;
